import type { GraphNode } from '@/types/graph.types';

export type GraphIdStrategy =
  | 'businessProperties'
  | 'topLevelId'
  | 'elementId';

type IdCarrier = GraphNode | Record<string, unknown> | null | undefined;

function readString(value: unknown): string | null {
  if (value === undefined || value === null) return null;
  const s = String(value).trim();
  return s.length > 0 ? s : null;
}

export function getGraphBusinessId(
  node: IdCarrier,
  strategy: GraphIdStrategy = 'businessProperties',
): string {
  if (!node || typeof node !== 'object') return '';

  const props = (node as GraphNode).properties;
  const businessId = readString(props?.id);

  if (strategy === 'businessProperties') {
    if (businessId) return businessId;
    return (
      readString((node as GraphNode).id) ??
      readString((node as Record<string, unknown>).element_id) ??
      readString((node as Record<string, unknown>).node_id) ??
      ''
    );
  }

  if (strategy === 'topLevelId') {
    return (
      readString((node as GraphNode).id) ??
      readString((node as Record<string, unknown>).element_id) ??
      businessId ??
      ''
    );
  }

  return (
    readString((node as Record<string, unknown>).element_id) ??
    readString((node as GraphNode).id) ??
    businessId ??
    ''
  );
}

export function findGraphNodeByBusinessId(
  nodes: GraphNode[],
  businessId: string,
): GraphNode | undefined {
  if (!businessId) return undefined;
  return nodes.find(
    (n) => getGraphBusinessId(n, 'businessProperties') === businessId,
  );
}
